'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z' });

var LineWeight = function LineWeight(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

LineWeight = (0, _pure2.default)(LineWeight);
LineWeight.muiName = 'SvgIcon';

exports.default = LineWeight;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/LineWeight.js
// module id = 2547
// module chunks = 0